var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtudiantsTotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7011_7995)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7011_7995)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(2.5 2.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6887 17.0181C15.3828 17.0181 16.0612 16.8123 16.6383 16.4267C17.2154 16.0411 17.6652 15.493 17.9307 14.8518C18.1963 14.2105 18.2658 13.5049 18.1303 12.8242C17.9949 12.1435 17.6606 11.5183 17.1698 11.0276C16.679 10.5368 16.0537 10.2027 15.3729 10.0674C14.6922 9.93202 13.9866 10.0016 13.3455 10.2673C12.7043 10.533 12.1563 10.9828 11.7708 11.56C11.3853 12.1371 11.1796 12.8156 11.1797 13.5097C11.1807 14.44 11.5507 15.3319 12.2086 15.9896C12.8665 16.6474 13.7584 17.0173 14.6887 17.0181Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2829 19.9187C18.3937 19.0066 17.2528 18.3803 16.0059 18.1198C14.7591 17.8593 13.4629 17.9764 12.2829 18.4561C11.1029 18.9358 10.0927 19.7563 9.38129 20.813C8.66991 21.8696 8.28964 23.1143 8.28906 24.388C8.28906 24.5509 8.35375 24.707 8.4689 24.8222C8.58405 24.9373 8.74022 25.002 8.90307 25.002H20.4832C20.6461 25.002 20.8023 24.9373 20.9174 24.8222C21.0326 24.707 21.0972 24.5509 21.0972 24.388C21.0996 23.737 20.9991 23.0896 20.7994 22.4699C20.5022 21.5118 19.9825 20.6376 19.2829 19.9187Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1017 17.3284C23.5429 17.3284 24.7112 16.1601 24.7112 14.7189C24.7112 13.2777 23.5429 12.1094 22.1017 12.1094C20.6605 12.1094 19.4922 13.2777 19.4922 14.7189C19.4922 16.1601 20.6605 17.3284 22.1017 17.3284Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1025 18.043C21.2795 18.0461 20.4724 18.2702 19.7656 18.692C19.8989 18.8111 20.0333 18.9284 20.1592 19.0573C20.9952 19.9166 21.6163 20.9614 21.9718 22.1065C22.0935 22.4834 22.1832 22.87 22.2401 23.262H26.0936C26.2564 23.262 26.4126 23.1973 26.5277 23.0822C26.6429 22.967 26.7076 22.8109 26.7076 22.648C26.7063 21.4271 26.2207 20.2565 25.3574 19.3932C24.494 18.5299 23.3235 18.0443 22.1025 18.043Z",
    fill: "#0A0A0B"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 34.5,
    height: 34.5,
    stroke: "#E6E6E7",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7011_7995",
    x: 0.5,
    y: 2.5,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7011_7995"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.627451 0 0 0 0 0.698039 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7011_7995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7011_7995",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7011_7995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtudiantsTotIcon);
export default __webpack_public_path__ + "static/media/etudiantsTotIcon.2a53c8d6ce19ec2f1af798ac5c335ef9.svg";
export { ForwardRef as ReactComponent };